
import Image from '@ingka/image';
import Text from '@ingka/text';
import './page.scss';
import { LoginButton } from './login-button';
import Ikea_logo from '../../images/Ikea_logo.svg'

export const LoginPage = () => {
    return (
        <>
        <div className='login_container'>
            <header>
                <Image src={Ikea_logo} alt='IKEA logo' />
            </header>
            <div>
                <Text tagName='h1' textStyle='Heading.L' className='lp-container'>
                    <p>Hej!</p>
                    <div>
                        <h2 className='lp-login'>
                            Welcome to PPS. Please log in.
                        </h2>
                        <LoginButton />
                    </div>
                </Text>
            </div>
        </div>
        </>
    );
}